import { createApiHook, useApi } from "../utils/apiUtils";

const useDeleteAspect = () => {
  const { apiDelete } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const deleteAspect = async (id) => {
    startLoading();
    const res = await apiDelete(`/aspects/${id}`, "Error al eliminar el aspecto");
    setResponse(res);

    if (res?.error) {
      const err = new Error(res.error.message || "No se pudo eliminar el aspecto");
      err.backend = res.error;
      throw err;
    }
    return true;
  };

  return { deleteAspect, data, loading, error };
};

export default useDeleteAspect;
